import { mapState, mapActions, mapMutations } from "vuex";
import AppIcon from "@/components/AppIcon";
import CustomAccountQuickSearchElement from "@/components/shared/CustomAccountQuickSearchElement";
import { EVENTS } from "@/utils";
import { resetLocalStorage } from "@/utils/storage";
export default {
  name: "TopAccount",
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isHovering: {
      type: Boolean,
      default: false
    },
    showTopAccountListView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      topAccountNameLoading: false,
      searchQuery: "",
      colors: ["#E7747A", "#5DE481", "#00A7FF", "#9447FF"],
      accountSettingOptions: [{
        name: "amazonConnections",
        text: "Amazon connections",
        url: "/connections",
        icon: "account-connection",
        featureName: "default"
      }, {
        name: "accountSettings",
        text: "Account settings",
        url: "/account",
        icon: "account-setting",
        tab: "workspace_detail",
        featureName: "default"
      }],
      isSearchBarFocused: false
    };
  },
  computed: {
    ...mapState({
      workspaces: state => state.workspace.list,
      current_workspace: state => state.workspace.current_workspace,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      members: state => state.member.list
    }),
    searchPlaceHolder() {
      return `Search account (${this.totalWorkspaces})`;
    },
    workspaceName() {
      const workspace = this.current_workspace;
      return workspace ? workspace.workspace_name : "";
    },
    firstLetterOfWorkspace() {
      return this.workspaceName ? this.workspaceName.charAt(0) : "";
    },
    totalWorkspaces() {
      return this.filteredWorkspaces.length;
      //return this.workspaces.length;
    },
    topWorkspacesList() {
      return this.workspaces;
    },
    filteredWorkspaces() {
      if (this.searchQuery) {
        return this.workspaces.filter(workspace => workspace.workspace_name.toLowerCase().includes(this.searchQuery.toLowerCase()) || workspace.workspace_id.toLowerCase().includes(this.searchQuery.toLowerCase()));
      }
      return this.workspaces;
    },
    sortedWorkspaces() {
      return this.filteredWorkspaces.filter(workspace => workspace.workspace_name !== this.current_workspace.workspace_name).sort((a, b) => a.workspace_name.localeCompare(b.workspace_name)).map((workspace, index) => ({
        ...workspace,
        firstLetter: workspace.workspace_name.charAt(0),
        colorIndex: index % this.colors.length
      })).slice(0, 12);
    }
  },
  async mounted() {
    await this.memberList({
      workspace_id: this.current_workspace.workspace_id
    });
  },
  methods: {
    ...mapActions(["memberList", "workspaceCurrent", "workspaceChange", "accountList", "workspaceList", "authLogout"]),
    ...mapMutations(["currentTabSet"]),
    onAccountSettingClick(item) {
      if (item.url == "/account") {
        this.currentTabSet(item.tab);
      }
      this.$router.push(item.url);
      this.toggleTopAccountListView();
    },
    handleSearchBarFocused() {
      this.isSearchBarFocused = true;
    },
    handleSearchBarBlured() {
      this.isSearchBarFocused = false;
    },
    toggleTopAccountListView() {
      this.$emit("list-view-toggled");
    },
    async onCurrentChange(workspace_id) {
      this.topAccountNameLoading = true;
      await resetLocalStorage();
      await this.workspaceChange({
        workspace_id: workspace_id
      });
      this.toggleTopAccountListView();
      //this.$router.go(0);
      window.$bus.trigger(EVENTS.REFRESH_APPLICATION);
      this.topAccountNameLoading = false;
    },
    async onClick(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
      if (item.action) {
        this.loading = true;
        await this.authLogout();
        this.loading = false;
        this.$router.push("/login");
      }
    },
    handleAccountSearch(accountToSearch) {
      //console.log('[top account search ]');
      //console.log(accountToSearch);
      this.searchQuery = accountToSearch.value[0];
    },
    navigateToAddAccount() {
      this.$emit("list-view-toggled");
      this.$router.push({
        path: "/manage-accounts",
        query: {
          openModal: "addAccountFromTop"
        }
      });
    },
    navigateToManageAccount() {
      this.$emit("list-view-toggled");
      this.onClick({
        url: '/manage-accounts'
      });
    },
    navigateToBrandPortfolio() {
      this.$router.push({
        path: "/brand-portfolio"
      });
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: "portfolioModuleOpened",
        properties: {}
      });
    }
  },
  components: {
    AppIcon,
    CustomAccountQuickSearchElement
  }
};